module.exports = __webpack_public_path__ + "static/Arvo-Regular-15e7b841171fa25cbb6d73d6da01cb4b.woff";